import React from "react";
import { Route, Navigate } from "react-router-dom";
import * as localStorageService from "./service/localStorageService";

const PrivateRoute = ({ children }) => {
 let authToken = localStorageService.getValue('authToken');

  if (!authToken) {
    return <Navigate to="/login" replace />
  }

  return children;
};

export default PrivateRoute;


